// extracted by mini-css-extract-plugin
export default {"sidebar":"Grid_sidebar__rtUqC","logo":"Grid_logo__stwO7","main":"Grid_main__HVBQC","gallery":"Grid_gallery__ihTeg"};